export default {
  BANNER: 'https://igamio.com/appapi/api_igamio.php?type=banner',
  POP_UP: 'https://igamio.com/appapi/api_igamio.php?type=popup',
  SPORTS_FACT_LIST: 'https://igamio.com/appapi/sportsfactslis.php'
};
